import { styled } from "@linaria/react"
import { type ReactNode } from "react"

import { AgentIterationStyles } from "@/components/AgentIteration/AgentIterationStyles.ts"
import { Dialog } from "@/components/Dialog/Dialog.tsx"
import { ExecResultTerminalModel } from "@/components/ReasoningStep/ExecResultTerminalModel.ts"
import { useModel } from "@/hooks/useModel.ts"
import { useOrgContext } from "@/hooks/useRootContext.ts"
import { TaskPreviewTerminal } from "@/routes/tasks/TaskViewScene/TaskPreviewTerminal.tsx"

import type { TID } from "@/lib/client/generated/TypeDefinitions.ts"

export const TerminalDialog = (props: {
  execResultId: TID | null,
  taskId: string | null,
  children: ReactNode,
  commandId?: string,
  previewId?: string,
  title?: string
}) => {
  if (!props.execResultId || !props.taskId) {
    return (
      <>
        {props.children}
      </>
    )
  }

  return (
    <Dialog
      title={props.title ?? "Command Output"}
      trigger={
        <ClickableStep>
          {props.children}
        </ClickableStep>
      }
    >
      <TerminalDialogInner
        execResultId={props.execResultId}
        taskId={props.taskId}
        commandId={props.commandId}
        previewId={props.previewId}
        title={props.title}
      />
    </Dialog>
  )
}

const TerminalDialogInner = (props: {
  execResultId: TID,
  taskId: string,
  commandId?: string,
  previewId?: string,
  title?: string
}) => {
  const context = useOrgContext()
  const model = useModel(() => {
    return new ExecResultTerminalModel({
      execResultId: props.execResultId,
      queries: context.queries,
      taskId: props.taskId,
      commandId: props.commandId,
      previewId: props.previewId
    })
  }, [props.execResultId, props.taskId, context.queries, props.commandId, props.previewId])

  return (
    <TaskPreviewTerminal model={model.terminalModel} backgroundColor="#FFF" />
  )
}

const ClickableStep = styled.div`
  cursor: pointer;

  &:hover {
    .${AgentIterationStyles.secondLevelMarkdown} {
      color: var(--main-color);
    }
  }
`